import { ILoadingState } from './types';

export const loadingInitialState: ILoadingState = {
  active: false,
  count: 0,
};
